import React from 'react';
import DashboardPage from '../../Planning/pages/DashboardPage';
import ParametersPage from '../../Planning/pages/ParametersPage';
import ProfilPage from '../../Planning/pages/ProfilPage';
import { ZoomButtonTest } from '../components/ZoomButtonTest';
import { ZoomTestSimple } from '../components/ZoomTestSimple';

import {
    ShoppingCart,
    Tune,
    Badge,
    Search,
    Person as PersonIcon,
    Business,
    LocalShipping,
    Route as RouteIcon,
    Build,
    Dashboard,
    Handyman,
    Description,
    Notifications,
    LocationOn,
    ReportProblem,
    Store,
    LocalGasStation,
    CreditCard,
    Speed,
    TrendingUp,
    PieChart,
    Message,
    CloudUpload,
    Traffic as TrafficIcon,
    Link as LinkIcon,
    Assessment,
    Explore,
    Domain,
    SupportAgent
} from '@mui/icons-material';

// Parc Imports
import ParcDashboard from '../../Parc/pages/Dashboard';
import VehiclesPage from '../../Parc/pages/Vehicles';
import DriversPage from '../../Parc/pages/Drivers';
import TripsPage from '../../Parc/pages/Trips';
import MaintenancePage from '../../Parc/pages/Maintenance';
import RepairsPage from '../../Parc/pages/Repairs';
import DocumentsPage from '../../Parc/pages/Documents';
import NotificationsPage from '../../Parc/pages/Notifications';
import SettingsPage from '../../Parc/pages/Settings';
import GpsTrackingPage from '../../Parc/pages/GpsTracking';
import GpsAlertsPage from '../../Parc/pages/GpsAlerts';
import FuelPage from '../../Parc/pages/Fuel';
import FuelCardsPage from '../../Parc/pages/FuelCards';
import MileagePage from '../../Parc/pages/Mileage';
import LookupsPage from '../../Parc/pages/Lookups';
import GeneralAnalysisPage from '../../Parc/pages/GeneralAnalysis';
import TcoAnalysisPage from '../../Parc/pages/TcoAnalysis';
import AlertMessagesPage from '../../Parc/pages/AlertMessages';
import MigrationExcelPage from '../../Parc/pages/MigrationExcel';

import UsersPage from '../../Planning/pages/UsersPage';
import { MenuConfigPage } from '../pages/MenuConfigPage';
import { KpiConfigPage } from '../pages/KpiConfigPage';
import SystemParametersPage from '../pages/SystemParametersPage';
import UserDossierPage from '../../Planning/pages/UserDossierPage';
import AgencyPage from '../../Planning/pages/AgencyPage';
import SecurityWebPage from '../pages/SecurityWeb/SecurityWebPage';
import { Security, DashboardCustomize } from '@mui/icons-material';

import ProjectsPage from '../../Maker/pages/Projects';
import EstimatesPage from '../../Maker/pages/Estimates';
import DesignPage from '../../Maker/pages/Design';
import ProductionPage from '../../Maker/pages/Production';
import MaterialsPage from '../../Maker/pages/Materials';
import CustomersPage from '../../Maker/pages/Customers';
import ProfilesPage from '../../Maker/pages/Profiles';
import ReportsPage from '../../Maker/pages/Reports';
import MakerDashboardPage from '../../Maker/pages/Dashboard';
import ComponentsPage from '../../Maker/pages/ComponentsPage';
import TemplatesPage from '../../Maker/pages/TemplatesPage';
import GammePage from '../../Maker/pages/Gamme';
import { Receipt, Settings, Print, Extension, ViewQuilt, LibraryBooks, CalendarMonth, School } from '@mui/icons-material';

// Traffic (traçage du trafic API)
import TrafficPage from '../pages/TrafficPage';
// Actions utilisateur (journal TABP_SYS_USER_ACTION_DATA)
import UserActionsPage from '../pages/UserActionsPage';
// Connexions utilisateur (TABP_SYS_CONNEXION)
import UserConnexionsPage from '../pages/UserConnexionsPage';

// Academy Imports
import AcademyDashboard from '../../Academy/pages/DashboardPage';
import AcademyRooms from '../../Academy/pages/RoomsPage';
import AcademyRoomRentals from '../../Academy/pages/RoomRentalsPage';
import AcademyTeachers from '../../Academy/pages/TeachersPage';
import AcademyStudents from '../../Academy/pages/StudentsPage';
import AcademyCourseTemplates from '../../Academy/pages/CourseTemplatesPage';
import AcademyGroups from '../../Academy/pages/GroupsPage';
import AcademyScheduler from '../../Academy/pages/SchedulerPage';
import AcademyAttendance from '../../Academy/pages/AttendancePage';
import AcademyFinancial from '../../Academy/pages/FinancialPage';
import AcademyReports from '../../Academy/pages/ReportsPage';
import AcademyQuizzes from '../../Academy/pages/QuizzesPage';
import AcademyQuizQuestions from '../../Academy/pages/QuizQuestionsPage';
import AcademyQuizAttempts from '../../Academy/pages/QuizAttemptsPage';
import AcademyParameters from '../../Academy/pages/AcademyParametersPage';
import AcademyPlanningControls from '../../Academy/pages/PlanningControlsPage';
import AcademyDiscounts from '../../Academy/pages/DiscountsPage';
import AcademyDiscountValidations from '../../Academy/pages/DiscountValidationsPage';
// boubaker 23/08/2026 - pages d'impression Academy (menu Impressions)
import AcademyPrintPlanning from '../../Academy/pages/PrintPlanningPage';
import AcademyPrintInvoices from '../../Academy/pages/PrintInvoicesPage';
import AcademyPrintReceipts from '../../Academy/pages/PrintReceiptsPage';
import AcademyPrintDailyCash from '../../Academy/pages/PrintDailyCashPage';
import AcademyPrintAttendanceSheet from '../../Academy/pages/PrintAttendanceSheetPage';
import AcademyPrintSchoolCertificate from '../../Academy/pages/PrintSchoolCertificatePage';
import AcademyPrintRegistrationForm from '../../Academy/pages/PrintRegistrationFormPage';
import AcademyPrintStudentsList from '../../Academy/pages/PrintStudentsListPage';
import AcademyPrintInformationSheet from '../../Academy/pages/PrintInformationSheetPage';
import AcademyPrintStudentCards from '../../Academy/pages/PrintStudentCardsPage';
import AcademyPrintCancellationCertificate from '../../Academy/pages/PrintCancellationCertificatePage';
import AcademyPrintConductCertificate from '../../Academy/pages/PrintConductCertificatePage';
import AcademyPrintParentConvocation from '../../Academy/pages/PrintParentConvocationPage';
import AcademyPrintEmergencyForm from '../../Academy/pages/PrintEmergencyFormPage';
import AcademyEditionsHub from '../../Academy/pages/EditionsHubPage';
import AcademyIndicateurMailLog from '../../Academy/pages/IndicateurMailLogPage';
import AcademyEmailTemplates from '../../Academy/pages/EmailTemplatesPage';
import AcademySubscription from '../../Academy/pages/SubscriptionPage';
import AcademyImportData from '../../Academy/pages/ImportDataPage';
import AcademyExportData from '../../Academy/pages/ExportDataPage';
import TheoreticalPlanningManagePage from '../../Academy/pages/TheoreticalPlanningManagePage';
import TheoreticalPlanningMatrixPage from '../../Academy/pages/TheoreticalPlanningMatrixPage';
import PlanningGenerationPage from '../../Academy/pages/PlanningGenerationPage';
import PlanningDeletionPage from '../../Academy/pages/PlanningDeletionPage';
import {
    LocalOffer, Drafts as DraftsIcon, FolderSpecial, AssignmentTurnedIn, Flag, Groups, EventNote,
    FactCheck, School as SchoolIcon, ContactPage, TransferWithinAStation, Verified, GridView, LocalHospital, MailOutline,
    CardMembership as SubscriptionIcon, UploadFile as UploadFileIcon, FileDownload as FileDownloadIcon,
    AutoAwesome, DeleteSweep
} from '@mui/icons-material';

// CRM Imports
import CrmDashboard from '../../CRM/pages/DashboardPage';
import CrmLeads from '../../CRM/pages/LeadsPage';
import CrmContacts from '../../CRM/pages/ContactsPage';
import CrmOpportunities from '../../CRM/pages/OpportunitiesPage';
import CrmActivities from '../../CRM/pages/ActivitiesPage';
import CrmOrganisations from '../../CRM/pages/OrganisationsPage';
import CrmVisits from '../../CRM/pages/VisitsPage';
import CrmCdc from '../../CRM/pages/CdcPage';
import CrmChantiers from '../../CRM/pages/ChantiersPage';
import CrmReclamations from '../../CRM/pages/ReclamationsPage';

// ProjectManagement Imports
import ProjectDashboard from '../../ProjectManagement/pages/DashboardPage';
import ProjectPortfolio from '../../ProjectManagement/pages/ProjectsPage';
import ProjectTasks from '../../ProjectManagement/pages/TasksPage';
import ProjectMilestones from '../../ProjectManagement/pages/MilestonesPage';
import ProjectTeam from '../../ProjectManagement/pages/TeamPage';

export interface RouteConfig {
    path: string;
    component: React.ReactNode;
    title: string;
    translationKey?: string;
    closable: boolean;
    protected: boolean;
    icon?: React.ReactNode;
}


export const routes: RouteConfig[] = [
    {
        path: '/bmsyu_config_menu', // Matching menuConfig.tsx href
        component: <MenuConfigPage />,
        title: 'Configuration Menu',
        translationKey: 'menu.planning.admin.configMenu',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/bmsyu_config_kpi',
        component: <KpiConfigPage />,
        title: 'Affectation KPIs Profil',
        translationKey: 'menu.planning.admin.configKpi',
        closable: true,
        protected: true,
        icon: <DashboardCustomize />
    },
    {
        path: '/dashboard',
        component: <DashboardPage />,
        title: 'Tableau de bord',
        translationKey: 'menu.default.dashboard',
        closable: false,
        protected: true,
        icon: <ShoppingCart /> // Matching "Commande" icon
    },
    {
        path: '/parametres',
        component: <ParametersPage />,
        title: 'Paramètres',
        translationKey: 'menu.planning.admin.parameters',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Profil',
        component: <ProfilPage />,
        title: 'Profil',
        translationKey: 'menu.planning.admin.accessRights.profiles',
        closable: true,
        protected: true,
        icon: <Badge />
    },
    {
        path: '/test-zoom',
        component: <ZoomButtonTest />,
        title: 'Test Zoom',
        closable: true,
        protected: false,
        icon: <Search />
    },
    {
        path: '/test-zoom-simple',
        component: <ZoomTestSimple />,
        title: 'Test Zoom Simple',
        closable: true,
        protected: false,
        icon: <Search />
    },
    {
        path: '/Utilisateurs',
        component: <UsersPage />,
        title: 'Utilisateurs',
        translationKey: 'menu.planning.admin.accessRights.users',
        closable: true,
        protected: true,
        icon: <PersonIcon />
    },
    {
        path: '/sys_parameters',
        component: <SystemParametersPage />,
        title: 'Paramètres Système',
        translationKey: 'menu.planning.admin.accessRights.sysParams',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/security-web',
        component: <SecurityWebPage />,
        title: 'Sécurité Web',
        translationKey: 'menu.planning.admin.securityWeb',
        closable: true,
        protected: true,
        icon: <Security />
    },
    {
        path: '/user-dossiers',
        component: <UserDossierPage />,
        title: 'Affectation Dossiers',
        translationKey: 'menu.planning.admin.userDossiers',
        closable: true,
        protected: true,
        icon: <Business />
    },
    {
        path: '/Agences',
        component: <AgencyPage />,
        title: 'Agences',
        translationKey: 'menu.planning.admin.societe.agence',
        closable: true,
        protected: true,
        icon: <Store />
    },
    // MAKER Routes
    {
        path: '/Maker/dashboard',
        component: <MakerDashboardPage />,
        title: 'Maker Dashboard',
        translationKey: 'menu.maker.dashboard',
        closable: false,
        protected: true,
        icon: <Business />
    },
    {
        path: '/Maker/projects',
        component: <ProjectsPage />,
        title: 'Projects',
        translationKey: 'menu.maker.projects',
        closable: true,
        protected: true,
        icon: <Business />
    },
    {
        path: '/Maker/projects/:id',
        component: <DesignPage />,
        title: 'Design Project',
        translationKey: 'menu.maker.design',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Maker/estimates',
        component: <EstimatesPage />,
        title: 'Estimates',
        translationKey: 'menu.maker.estimates',
        closable: true,
        protected: true,
        icon: <Receipt />
    },
    {
        path: '/Maker/design',
        component: <DesignPage />,
        title: 'Design',
        translationKey: 'menu.maker.design',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Maker/production',
        component: <ProductionPage />,
        title: 'Production',
        translationKey: 'menu.maker.production',
        closable: true,
        protected: true,
        icon: <Settings />
    },
    {
        path: '/Maker/materials',
        component: <MaterialsPage />,
        title: 'Materials',
        translationKey: 'menu.maker.materials',
        closable: true,
        protected: true,
        icon: <ShoppingCart />
    },
    {
        path: '/Maker/profiles',
        component: <ProfilesPage />,
        title: 'Profiles',
        translationKey: 'menu.maker.profiles',
        closable: true,
        protected: true,
        icon: <Settings /> // Using Settings icon or Inventory if available
    },
    {
        path: '/Maker/customers',
        component: <CustomersPage />,
        title: 'Customers',
        translationKey: 'menu.maker.customers',
        closable: true,
        protected: true,
        icon: <PersonIcon />
    },
    {
        path: '/Maker/reports',
        component: <ReportsPage />,
        title: 'Reports',
        translationKey: 'menu.maker.reports',
        closable: true,
        protected: true,
        icon: <Print />
    },
    {
        path: '/Maker/components',
        component: <ComponentsPage />,
        title: 'Components',
        translationKey: 'menu.maker.components',
        closable: true,
        protected: true,
        icon: <Extension />
    },
    {
        path: '/Maker/templates',
        component: <TemplatesPage />,
        title: 'Templates',
        translationKey: 'menu.maker.templates',
        closable: true,
        protected: true,
        icon: <ViewQuilt />
    },
    {
        path: '/Maker/gamme',
        component: <GammePage />,
        title: 'Gammes',
        translationKey: 'maker.gamme.title',
        closable: true,
        protected: true,
        icon: <LibraryBooks />
    },
    // PARC Routes
    {
        path: '/Parc/dashboard',
        component: <ParcDashboard />,
        title: 'Tableau de bord',
        closable: false,
        protected: true,
        icon: <Dashboard />
    },
    {
        path: '/Parc/vehicles',
        component: <VehiclesPage />,
        title: 'Véhicules',
        closable: true,
        protected: true,
        icon: <LocalShipping />
    },
    {
        path: '/Parc/drivers',
        component: <DriversPage />,
        title: 'Chauffeurs',
        closable: true,
        protected: true,
        icon: <PersonIcon />
    },
    {
        path: '/Parc/trips',
        component: <TripsPage />,
        title: 'Trajets',
        closable: true,
        protected: true,
        icon: <RouteIcon />
    },
    {
        path: '/Parc/maintenance',
        component: <MaintenancePage />,
        title: 'Maintenance',
        closable: true,
        protected: true,
        icon: <Build />
    },
    {
        path: '/Parc/repairs',
        component: <RepairsPage />,
        title: 'Réparations',
        closable: true,
        protected: true,
        icon: <Handyman />
    },
    {
        path: '/Parc/documents',
        component: <DocumentsPage />,
        title: 'Documents',
        closable: true,
        protected: true,
        icon: <Description />
    },
    {
        path: '/Parc/notifications',
        component: <NotificationsPage />,
        title: 'Notifications',
        closable: true,
        protected: true,
        icon: <Notifications />
    },
    {
        path: '/Parc/settings',
        component: <SettingsPage />,
        title: 'Paramètres',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Parc/gps-tracking',
        component: <GpsTrackingPage />,
        title: 'Suivi GPS',
        closable: true,
        protected: true,
        icon: <LocationOn />
    },
    {
        path: '/Parc/gps-alerts',
        component: <GpsAlertsPage />,
        title: 'Alertes GPS',
        closable: true,
        protected: true,
        icon: <ReportProblem />
    },
    {
        path: '/Parc/fuel',
        component: <FuelPage />,
        title: 'Carburant',
        closable: true,
        protected: true,
        icon: <LocalGasStation />
    },
    {
        path: '/Parc/fuel-cards',
        component: <FuelCardsPage />,
        title: 'Cartes Carburant',
        closable: true,
        protected: true,
        icon: <CreditCard />
    },
    {
        path: '/Parc/mileage',
        component: <MileagePage />,
        title: 'Kilométrage',
        closable: true,
        protected: true,
        icon: <Speed />
    },
    {
        path: '/Parc/analysis',
        component: <GeneralAnalysisPage />,
        title: 'Analyse Générale',
        closable: true,
        protected: true,
        icon: <TrendingUp />
    },
    {
        path: '/Parc/tco',
        component: <TcoAnalysisPage />,
        title: 'Analyse TCO',
        closable: true,
        protected: true,
        icon: <PieChart />
    },
    {
        path: '/Parc/alerts',
        component: <AlertMessagesPage />,
        title: 'Message d\'alertes',
        closable: true,
        protected: true,
        icon: <Message />
    },
    {
        path: '/Parc/lookups',
        component: <LookupsPage />,
        title: 'Tables de Référence',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Parc/migration',
        component: <MigrationExcelPage />,
        title: 'Migration de Données',
        closable: true,
        protected: true,
        icon: <CloudUpload />
    },
    // ACADEMY Routes
    {
        path: '/Academy/dashboard',
        component: <AcademyDashboard />,
        title: 'Mission Control Dashboard',
        translationKey: 'academy.menu.dashboard',
        closable: false,
        protected: true,
        icon: <Dashboard />
    },
    {
        path: '/Academy/rooms',
        component: <AcademyRooms />,
        title: 'Rooms & Resources',
        translationKey: 'academy.menu.rooms',
        closable: true,
        protected: true,
        icon: <Business />
    },
    {
        path: '/Academy/room-rentals',
        component: <AcademyRoomRentals />,
        title: 'Locations de salle',
        translationKey: 'academy.menu.room_rentals',
        closable: true,
        protected: true,
        icon: <Business />
    },
    {
        path: '/Academy/teachers',
        component: <AcademyTeachers />,
        title: 'Teachers & Faculty',
        translationKey: 'academy.menu.teachers',
        closable: true,
        protected: true,
        icon: <Badge />
    },
    {
        path: '/Academy/students',
        component: <AcademyStudents />,
        title: 'Students & Enrollments',
        translationKey: 'academy.menu.students',
        closable: true,
        protected: true,
        icon: <PersonIcon />
    },
    {
        path: '/Academy/course-templates',
        component: <AcademyCourseTemplates />,
        title: 'Course Templates',
        translationKey: 'academy.menu.course_templates',
        closable: true,
        protected: true,
        icon: <School />
    },
    {
        path: '/Academy/quizzes',
        component: <AcademyQuizzes />,
        title: 'Quizzes & Tests',
        translationKey: 'academy.menu.quizzes.list',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Academy/quiz-questions',
        component: <AcademyQuizQuestions />,
        title: 'Quiz Questions',
        translationKey: 'academy.menu.quizzes.quiz_questions',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Academy/quiz-results',
        component: <AcademyQuizAttempts />,
        title: 'Quiz Results',
        translationKey: 'academy.menu.quizzes.quiz_results',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Academy/groups',
        component: <AcademyGroups />,
        title: 'Groups & Cohorts Kanban',
        translationKey: 'academy.menu.groups',
        closable: true,
        protected: true,
        icon: <ViewQuilt />
    },
    {
        path: '/Academy/scheduler',
        component: <AcademyScheduler />,
        title: 'Weekly Scheduler Matrix',
        translationKey: 'academy.menu.scheduler',
        closable: true,
        protected: true,
        icon: <CalendarMonth />
    },
    {
        path: '/Academy/planning-theorique-crud',
        component: <TheoreticalPlanningManagePage />,
        title: 'Gestion du planning théorique',
        translationKey: 'academy.menu.planning_theorique_crud',
        closable: true,
        protected: true,
        icon: <CalendarMonth />
    },
    {
        path: '/Academy/planning-theorique',
        component: <TheoreticalPlanningMatrixPage />,
        title: 'Planning théorique',
        translationKey: 'academy.menu.planning_theorique_matrix',
        closable: true,
        protected: true,
        icon: <CalendarMonth />
    },
    {
        path: '/Academy/generation-planning',
        component: <PlanningGenerationPage />,
        title: 'Génération planning',
        translationKey: 'academy.menu.planning_generation',
        closable: true,
        protected: true,
        icon: <AutoAwesome />
    },
    {
        path: '/Academy/delete-planning',
        component: <PlanningDeletionPage />,
        title: 'Suppression planning',
        translationKey: 'academy.menu.planning_deletion',
        closable: true,
        protected: true,
        icon: <DeleteSweep />
    },
    {
        path: '/Academy/attendance',
        component: <AcademyAttendance />,
        title: 'Attendance Execution',
        translationKey: 'academy.menu.attendance',
        closable: true,
        protected: true,
        icon: <Receipt />
    },
    {
        path: '/Academy/financial',
        component: <AcademyFinancial />,
        title: 'Financial & Payments',
        translationKey: 'academy.menu.financial',
        closable: true,
        protected: true,
        icon: <CreditCard />
    },
    {
        path: '/Academy/reports',
        component: <AcademyReports />,
        title: 'Reports & Analytics',
        translationKey: 'academy.menu.reports',
        closable: true,
        protected: true,
        icon: <TrendingUp />
    },
    // boubaker 23/08/2026 - Impressions Academy (planning, factures, reçus, caisse journalier)
    {
        path: '/Academy/print-planning',
        component: <AcademyPrintPlanning />,
        title: 'Print Planning',
        translationKey: 'academy.menu.prints.planning',
        closable: true,
        protected: true,
        icon: <Print />
    },
    {
        path: '/Academy/print-invoices',
        component: <AcademyPrintInvoices />,
        title: 'Print Invoices',
        translationKey: 'academy.menu.prints.invoices',
        closable: true,
        protected: true,
        icon: <Description />
    },
    {
        path: '/Academy/print-receipts',
        component: <AcademyPrintReceipts />,
        title: 'Print Payment Receipts',
        translationKey: 'academy.menu.prints.receipts',
        closable: true,
        protected: true,
        icon: <Receipt />
    },
    {
        path: '/Academy/print-daily-cash',
        component: <AcademyPrintDailyCash />,
        title: 'Daily Cash Balance Report',
        translationKey: 'academy.menu.prints.daily_cash',
        closable: true,
        protected: true,
        icon: <Print />
    },
    // boubaker 12/09/2026 - Nouvelles éditions scolaires Academy
    {
        path: '/Academy/editions',
        component: <AcademyEditionsHub />,
        title: "Centre d'éditions",
        translationKey: 'academy.menu.prints.hub',
        closable: true,
        protected: true,
        icon: <GridView />
    },
    {
        path: '/Academy/print-attendance-sheet',
        component: <AcademyPrintAttendanceSheet />,
        title: 'Feuille de présence',
        translationKey: 'academy.menu.prints.attendance_sheet',
        closable: true,
        protected: true,
        icon: <FactCheck />
    },
    {
        path: '/Academy/print-school-certificate',
        component: <AcademyPrintSchoolCertificate />,
        title: 'Certificat de scolarité',
        translationKey: 'academy.menu.prints.school_certificate',
        closable: true,
        protected: true,
        icon: <SchoolIcon />
    },
    {
        path: '/Academy/print-registration-form',
        component: <AcademyPrintRegistrationForm />,
        title: "Fiche d'inscription",
        translationKey: 'academy.menu.prints.registration_form',
        closable: true,
        protected: true,
        icon: <Badge />
    },
    {
        path: '/Academy/print-students-list',
        component: <AcademyPrintStudentsList />,
        title: 'Liste des apprenants',
        translationKey: 'academy.menu.prints.students_list',
        closable: true,
        protected: true,
        icon: <Groups />
    },
    {
        path: '/Academy/print-information-sheet',
        component: <AcademyPrintInformationSheet />,
        title: 'Fiche de renseignements',
        translationKey: 'academy.menu.prints.information_sheet',
        closable: true,
        protected: true,
        icon: <ContactPage />
    },
    {
        path: '/Academy/print-student-cards',
        component: <AcademyPrintStudentCards />,
        title: "Badge d'apprenant",
        translationKey: 'academy.menu.prints.student_cards',
        closable: true,
        protected: true,
        icon: <Badge />
    },
    {
        path: '/Academy/print-cancellation-certificate',
        component: <AcademyPrintCancellationCertificate />,
        title: 'Certificat de radiation',
        translationKey: 'academy.menu.prints.cancellation_certificate',
        closable: true,
        protected: true,
        icon: <TransferWithinAStation />
    },
    {
        path: '/Academy/print-conduct-certificate',
        component: <AcademyPrintConductCertificate />,
        title: 'Certificat de bonne conduite',
        translationKey: 'academy.menu.prints.conduct_certificate',
        closable: true,
        protected: true,
        icon: <Verified />
    },
    {
        path: '/Academy/print-parent-convocation',
        component: <AcademyPrintParentConvocation />,
        title: 'Convocation du parent',
        translationKey: 'academy.menu.prints.parent_convocation',
        closable: true,
        protected: true,
        icon: <MailOutline />
    },
    {
        path: '/Academy/print-emergency-form',
        component: <AcademyPrintEmergencyForm />,
        title: "Fiche d'urgence et soins",
        translationKey: 'academy.menu.prints.emergency_form',
        closable: true,
        protected: true,
        icon: <LocalHospital />
    },
    // boubaker 25/08/2026 - Indicateur : traçabilité des envois mail
    {
        path: '/Academy/indicateur-mail-log',
        component: <AcademyIndicateurMailLog />,
        title: 'Traçabilité Envois Mail',
        translationKey: 'academy.menu.indicateur.mail_log',
        closable: true,
        protected: true,
        icon: <Assessment />
    },
    {
        path: '/Academy/traffic',
        component: <TrafficPage />,
        title: 'Trafic API',
        translationKey: 'academy.menu.traffic',
        closable: true,
        protected: true,
        icon: <TrafficIcon />
    },
    {
        path: '/Academy/user-actions',
        component: <UserActionsPage />,
        title: 'Actions Utilisateur',
        translationKey: 'academy.menu.user_actions',
        closable: true,
        protected: true,
        icon: <TrafficIcon />
    },
    {
        path: '/Academy/user-connexions',
        component: <UserConnexionsPage />,
        title: 'Connexions Utilisateur',
        translationKey: 'academy.menu.user_connexions',
        closable: true,
        protected: true,
        icon: <LinkIcon />
    },
    {
        path: '/Academy/academy-parameters',
        component: <AcademyParameters />,
        title: 'Paramètres Académie',
        translationKey: 'academy.menu.parameters',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Academy/planning-controls',
        component: <AcademyPlanningControls />,
        title: 'Contrôles Planning',
        translationKey: 'academy.menu.planning_controls',
        closable: true,
        protected: true,
        icon: <Tune />
    },
    {
        path: '/Academy/discounts',
        component: <AcademyDiscounts />,
        title: 'Politique Remises',
        translationKey: 'academy.menu.discounts',
        closable: true,
        protected: true,
        icon: <LocalOffer />
    },
    {
        path: '/Academy/discount-validations',
        component: <AcademyDiscountValidations />,
        title: 'Validation des Remises',
        translationKey: 'academy.menu.discount_validations',
        closable: true,
        protected: true,
        icon: <LocalOffer />
    },
    {
        path: '/Academy/email-templates',
        component: <AcademyEmailTemplates />,
        title: "Modèles d'Emails",
        translationKey: 'academy.menu.email_templates',
        closable: true,
        protected: true,
        icon: <DraftsIcon />
    },
    {
        path: '/Academy/subscription',
        component: <AcademySubscription />,
        title: 'Abonnement & Facturation',
        translationKey: 'academy.menu.subscription',
        closable: true,
        protected: true,
        icon: <SubscriptionIcon />
    },
    {
        path: '/Academy/import-data',
        component: <AcademyImportData />,
        title: 'Importer des données',
        translationKey: 'academy.menu.import_data',
        closable: true,
        protected: true,
        icon: <UploadFileIcon />
    },
    {
        path: '/Academy/export-data',
        component: <AcademyExportData />,
        title: 'Exporter des données',
        translationKey: 'academy.menu.export_data',
        closable: true,
        protected: true,
        icon: <FileDownloadIcon />
    },

    // CRM Routes
    {
        path: '/CRM/dashboard',
        component: <CrmDashboard />,
        title: 'Tableau de bord CRM',
        translationKey: 'crm.menu.dashboard',
        closable: false,
        protected: true,
        icon: <Dashboard />
    },
    {
        path: '/CRM/visits',
        component: <CrmVisits />,
        title: 'Visites Terrain',
        translationKey: 'crm.menu.visits',
        closable: true,
        protected: true,
        icon: <Explore />
    },
    {
        path: '/CRM/cdc',
        component: <CrmCdc />,
        title: 'Cahiers des Charges (CDC)',
        translationKey: 'crm.menu.cdc',
        closable: true,
        protected: true,
        icon: <Description />
    },
    {
        path: '/CRM/opportunities',
        component: <CrmOpportunities />,
        title: 'Projets & Opportunités',
        translationKey: 'crm.menu.opportunities',
        closable: true,
        protected: true,
        icon: <CreditCard />
    },
    {
        path: '/CRM/leads',
        component: <CrmLeads />,
        title: 'Prospects & Leads',
        translationKey: 'crm.menu.leads',
        closable: true,
        protected: true,
        icon: <TrendingUp />
    },
    {
        path: '/CRM/chantiers',
        component: <CrmChantiers />,
        title: 'Chantiers Actifs (KAM)',
        translationKey: 'crm.menu.chantiers',
        closable: true,
        protected: true,
        icon: <Store />
    },
    {
        path: '/CRM/reclamations',
        component: <CrmReclamations />,
        title: 'Réclamations & SAV',
        translationKey: 'crm.menu.reclamations',
        closable: true,
        protected: true,
        icon: <SupportAgent />
    },
    {
        path: '/CRM/organisations',
        component: <CrmOrganisations />,
        title: 'Organisations (BET / Promo)',
        translationKey: 'crm.menu.organisations',
        closable: true,
        protected: true,
        icon: <Domain />
    },
    {
        path: '/CRM/contacts',
        component: <CrmContacts />,
        title: 'Contacts & Décideurs',
        translationKey: 'crm.menu.contacts',
        closable: true,
        protected: true,
        icon: <PersonIcon />
    },
    {
        path: '/CRM/activities',
        component: <CrmActivities />,
        title: 'Activités & RDV',
        translationKey: 'crm.menu.activities',
        closable: true,
        protected: true,
        icon: <EventNote />
    },

    // ProjectManagement Routes
    {
        path: '/ProjectManagement/dashboard',
        component: <ProjectDashboard />,
        title: 'Tableau de bord Projets',
        translationKey: 'project.menu.dashboard',
        closable: false,
        protected: true,
        icon: <Dashboard />
    },
    {
        path: '/ProjectManagement/projects',
        component: <ProjectPortfolio />,
        title: 'Portefeuille de Projets',
        translationKey: 'project.menu.projects',
        closable: true,
        protected: true,
        icon: <FolderSpecial />
    },
    {
        path: '/ProjectManagement/tasks',
        component: <ProjectTasks />,
        title: 'Tâches & Activités',
        translationKey: 'project.menu.tasks',
        closable: true,
        protected: true,
        icon: <AssignmentTurnedIn />
    },
    {
        path: '/ProjectManagement/milestones',
        component: <ProjectMilestones />,
        title: 'Jalons & Livrables',
        translationKey: 'project.menu.milestones',
        closable: true,
        protected: true,
        icon: <Flag />
    },
    {
        path: '/ProjectManagement/team',
        component: <ProjectTeam />,
        title: 'Équipe & Ressources',
        translationKey: 'project.menu.team',
        closable: true,
        protected: true,
        icon: <Groups />
    }
];

// Helper to check if a path matches a route pattern
const matchRoute = (routePath: string, locationPath: string): boolean => {
    const routeParts = routePath.split('/');
    const locationParts = locationPath.split('/');

    if (routeParts.length !== locationParts.length) return false;

    return routeParts.every((part, i) => {
        return part.startsWith(':') || part === locationParts[i];
    });
};

export const getRouteByPath = (path: string): RouteConfig | undefined => {
    return routes.find(r => r.path === path || matchRoute(r.path, path));
};
